import React from "react";
import { useState, useEffect } from "react";
import "./LpGuts.css";
import { FaUserCircle, FaEnvelope, FaLandmark } from "react-icons/fa";
import { getCall, getCity } from "../../Redux/Actions";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Modal } from "react-responsive-modal";
import Popup from "../../components/PopupNotification/LpPopup";

const LpGuts = () => {
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [nameError, setNameEror] = useState("");
  const [phoneError, setPhoneEror] = useState("");
  const [userCity, setUserCity] = useState("");
  const [userGender, setUserGender] = useState("");
  const [userAge, setUserAge] = useState("");
  const [emailError, setEmailError] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();
  const [openSuccModel, setSucc] = useState(false);
  const [displayCityList, setDisplay] = useState(true);
  const [open1, setOpen1] = useState(false);
  const onOpenModal1 = () => setOpen1(true);
  const onCloseModal1 = () => setOpen1(false);

  const openSucess = () => setSucc(true);
  const closeSuccess = () => setSucc(false);

  useEffect(() => {
    dispatch(getCity());
  }, []);
  const navCity = useSelector((state) => state.navCityList);
  const { navCities } = navCity;
  const citiesFromArray = navCities;
  const cityList = useSelector((state) => state.cityList);
  const { cities, loading } = cityList;

  const handelUserName = (e) => {
    // setshowPopUp()
    setUserName(e.target.value);
    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };
  const setInputcity = (val) => {
    setUserCity(val);
    setDisplay(false);
  };
  const handelUserEmail = (e) => {
    setUserEmail(e.target.value);
    setEmailError("");
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!e.target.value.match(regex)) {
      setEmailError("invalid email address");
    }
    if (e.target.value == "") {
      setEmailError("");
    }
  };
  const handelUserAge = (e) => {
    // setshowPopUp()
    setUserAge(e.target.value);
  };
  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!userNumber.match(phoneno) || parseInt(userNumber[0]) < 6) {
      if (userNumber === "") {
        return false;
      } else {
        setPhoneEror("Enter a valid number");
        return false;
      }
    } else {
      return true;
    }
  };
  const handelPhoneChange = (e, userNumber) => {
    setUserNumber(e.target.value);
    setPhoneEror("");
  };
  const handelCityChange = (e) => {
    setUserCity(e.target.value);
    setDisplay(true);
  };
  const handelGender = (e) => {
    setUserGender(e.target.value);
  };
  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();
    if (checkVal) {
      const body = {
        name: userName,
        phone_no: userNumber,
        email: userEmail,
        calling_gender: userGender,
        patient_age: userAge,
        source: "Ecommerce",
        url: `https://redcliffelabs.com${location?.pathname}/Top/${location?.search}`,
        city: userCity,
      };
      openSucess();
      setUserNumber("");
      setUserName("");
      setUserCity("");
      setUserGender("");
      setUserAge("");
      setUserEmail("");
      //   openSucess("");
      dispatch(getCall(body));
    
    }
  };

  useEffect(() => {
    setTimeout(() => {
      onOpenModal1();
    }, 60000);
  }, []);

  return (
    <div className="lpGutsContainer">
      <div className="lpGutsHead">Microbiome - DNA Test</div>
      <div className="lpGutsAbout">
        <div className="lpGutsAboutTxt">
          <h1>All About Microbiome-DNA Test</h1>
          <p>
            Redcliffe Labs’ Microbiome DNA Test offers an in-depth insight into
            your overall health and well-being. This test examines the entire
            DNA of all the microorganisms present in the gut and provides more
            detailed information at a much higher resolution level. It also
            Identifies viruses, archaea, and fungi, as well as their metabolic
            activity and functionality.
          </p>
        </div>
        <div className="lpGutsAboutImg">
          <img
            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b6e20111-1306-48cc-aed1-1ef58cbed0be.png"
            alt=""
          />
        </div>
      </div>
      <div className="lpGutsSymptoms">
        <h1>SYMPTOMS THAT COULD BE AN INDICATION OF A GUT DISEASE:</h1>
        <div className="lpGutsCards">
          <div className="lpGutsCard">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/bf8f001e-8076-4382-bd9e-7040547030c2.png"
              alt=""
            />
            <div className="lpGutsCardTxt">Frequent Bloating and Gas</div>
          </div>
          <div className="lpGutsCard">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/7c013451-20bf-4481-a5be-e9f661963cf2.png"
              alt=""
            />
            <div className="lpGutsCardTxt">Chronic Constipation</div>
          </div>
          <div className="lpGutsCard">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/c7d16dd9-375c-498e-8d8a-dce6eaa48237.png"
              alt=""
            />
            <div className="lpGutsCardTxt lpGutsCardTxtFatigue ">
              Constant Fatigue
            </div>
          </div>
          <div className="lpGutsCard">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/35614751-48af-4d5f-9143-2d4418254a1c.png"
              alt=""
            />
            <div className="lpGutsCardTxt lpGutsCardTxtFatigue">
              Food Intolerance
            </div>
          </div>
          <div className="lpGutsCard">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/f35a0a7d-db9e-490c-900f-f6c671c5b8bb.png"
              alt=""
            />
            <div className="lpGutsCardTxt lpGutsCardTxtFatigue">
              Anxiety or Stress
            </div>
          </div>
        </div>
      </div>
      <div className="lpGutsWhy">
        <h1>Why Should You Take the Microbiome DNA Test?</h1>
        <p>
          It is an Evidence-based interpretation of your gut microbiome data,
          with the hope that it will guide you to better understand your health
          and make necessary changes to your lifestyle to lead a healthier life.
        </p>
        <p>
          To examine the presence of an unknown population in your gut that may
          be responsible for problematic symptoms which can worsen with time if
          not diagnosed early or timely.
        </p>
        <p>
          The establishment of the gut microbiome is quantitatively and
          functionally influenced by your diet and nutrition, and it is highly
          dynamic. Hence,{" "}
          <strong>
            {" "}
            we recommend you undergo re-testing of your gut every 3 months and
            renew your recommendations.
          </strong>
        </p>
      </div>
      <div className="lpGutsTesting">
        <div className="lpGutsTestingTxt">
          <h1>Testing Procedure</h1>
          <p>
            This test uses stool samples to examine your gut health. The
            Microbiome Test by Redcliffe Labs uses whole DNA sequencing to
            identify “good” and “bad” microbes in the GI tract, and give you a
            complete personalized lifestyle and dietary recommendations on the
            basis of your quantitative and qualitative results from your report.
          </p>
        </div>
        <img
          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/4453d16e-316e-4648-81a8-82c49e702b8c.png"
          alt=""
        />
      </div>
      <div className="lpGutsDietLife">
        <div className="lpGutsDiet">
          <h1>Dietary Recommendation</h1>
          <div className="lpGutsPhases">
            <div className="lpGutsPhasesCard">
              <h1>PHASE1</h1>
              <p>Restoring Your Gut Microbiome</p>
              <div className="lpGutsCal">
                <img
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/bc917b2b-7b6a-4fa7-9b74-1532c227f666.svg"
                  alt=""
                />
                <div className="lpGutCalTxt">
                  2 <br /> Weeks
                </div>
              </div>
            </div>
            <div className="lpGutsPhasesCard">
              <h1>PHASE2</h1>
              <p>Rebuilding Your Microbiome</p>
              <div className="lpGutsCal">
                <img
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/bc917b2b-7b6a-4fa7-9b74-1532c227f666.svg"
                  alt=""
                />
                <div className="lpGutCalTxt">
                  8 <br /> Weeks
                </div>
              </div>
            </div>
            <div className="lpGutsPhasesCard">
              <h1>PHASE3</h1>
              <p>Maintaining The Healthy Gut</p>
              <div className="lpGutsCal">
                <img
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/bc917b2b-7b6a-4fa7-9b74-1532c227f666.svg"
                  alt=""
                />
                <div className="lpGutCalTxt">
                  2 <br /> Weeks
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lpGutsLife">
          <h1>Lifestyle and Gut Microbiome</h1>
          <p>
            These Lifestyle and gut microbiome associations are algorithm-based
            output. This does not ensure any optimal performance or improved
            lifestyle. Each of these screened lifestyle aspects has been
            described at the end of this report to provide you with a basic
            understanding of associations between the gut microbiome and these
            lifestyle aspects.
          </p>
        </div>
      </div>
      <div className="lpGutsMoreInfo">
        <div className="lpGutsMoreInfoTxt">
          <h1>Get More Infomation</h1>
          <p>
            We are a state-of -art diagnostic lab with complete pathology
            solution offering a wide range of test menu spanning over 9 major
            departments. At Redcliffe labs we offer:
          </p>
          <p>
            <ul>
              <li>Pathology Services</li>
              <li>Hormone Testing</li>
              <li>Genomic Testing</li>
              <li>Routine Investigations</li>
            </ul>
          </p>
        </div>
        <div className="lpGutsMoreInfoForm">
          <form onSubmit={handelSubmit}>
            <div style={{ marginTop: "5rem" }} className="lpGutsFormInp">
              <span>
                <FaUserCircle />
              </span>
              <input
                onChange={handelUserName}
                value={userName}
                required
                type="text"
                placeholder="Enter Name"
              />
            </div>
            {nameError != "" ? (
              <span className="lpGutTestFormError">{nameError}</span>
            ) : null}
            <div className="lpGutsFormInp">
              <span style={{ fontSize: "22px" }}>+91</span>
              <input
                onBlur={() => {
                  validatePhoneNumber();
                }}
                onChange={handelPhoneChange}
                value={userNumber}
                type="text"
                placeholder="Enter Phone Number"
              />
            </div>
            {phoneError != "" ? (
              <span className="lpGutTestFormError">{phoneError}</span>
            ) : null}
            <div className="lpGutsFormInp">
              <span>
                <FaEnvelope />
              </span>
              <input
                required
                value={userEmail}
                onChange={handelUserEmail}
                type="text"
                placeholder="Enter Email Id"
              />
            </div>
            {emailError != "" ? (
              <span className="lpGutTestFormError">{emailError}</span>
            ) : null}
            <div className="lpGutsFormInpHalf">
              <div className="lpGutsFormInp">
                <span>
                  <FaUserCircle />
                </span>
                <select required onChange={handelGender} id="">
                  <option value="" disabled selected>
                    Gender*
                  </option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="lpGutsFormInp">
                <input
                  value={userAge}
                  onChange={handelUserAge}
                  required
                  type="text"
                  placeholder="Age"
                />
              </div>
            </div>
            <div className="lpGutsFormInp">
              <span>
                {" "}
                <FaLandmark />{" "}
              </span>
              <input
                onChange={handelCityChange}
                value={userCity}
                placeholder="Enter City*"
                type="text"
                style={{ marginRight: "3rem" }}
                required
              />
            </div>
            {displayCityList ? (
              <div
                className={
                  userCity ? "cityList lpGutcityListWeb" : "displayNone"
                }
                id="cityList"
              >
                {userCity !== "" && citiesFromArray && citiesFromArray.cities
                  ? citiesFromArray.cities
                      .filter((name) => {
                        if (userCity == "") {
                          return name;
                        } else if (
                          name.toLowerCase().includes(userCity.toLowerCase())
                        ) {
                          return name;
                        }
                      })
                      .map((values, index) => {
                        if (index < 2) {
                          return (
                            <>
                              <div
                                onClick={() => setInputcity(values)}
                                key={index}
                                className={
                                  displayCityList ? "cityLIstLP" : "displayNone"
                                }
                              >
                                <span>{values}</span>
                              </div>

                              {/* <div
                                className="cityItem"
                                key={index}
                                onClick={() => setCity(filteredName)}
                                >
                                {" "}
                                <span>{filteredName}</span>{" "}
                                </div> */}
                            </>
                          );
                        }
                      })
                  : null}
              </div>
            ) : null}
            <button type="submit">SUBMIT</button>
          </form>
        </div>
      </div>
      <div className="lpGutsDisclaimer noDisplayWeb">
        <h1>Contact Us</h1>
        <p>
          To know more about Redcliffe Labs or our Diagnostic Centre, please get
          in touch with our dedicated customer care team. Our team is available
          7 days a week to assist you with your queries.
        </p>
        <p>
          Apart from the Noida region, Redcliffe Lab is also a profound
          diagnostic centre all across India because of the patient-led approach
          and accurate screening tests with timely results.
        </p>
        <p style={{ color: "#A7A7A7", fontWeight: "500", marginTop: "25px" }}>
          Phone Number:
        </p>
        <p style={{ color: "#707070", fontWeight: "500" }}>+91 898 898 8787</p>
        <p style={{ color: "#A7A7A7", fontWeight: "500", marginTop: "25px" }}>
          Email:
        </p>
        <p style={{ color: "#707070", fontWeight: "500" }}>
          care@redcliffelabs.com
        </p>
        <p style={{ color: "#A7A7A7", fontWeight: "500", marginTop: "25px" }}>
          Address:
        </p>
        <p style={{ color: "#707070", fontWeight: "500" }}>
          H55 3rd Floor, Electronic City, Noida, Uttar Pradesh 201301
        </p>
      </div>
      <div className="lpGutsFormMob noDisplayWeb">
        <div className="lpGutsFormMobTxt">
          <h1>Get in touch with us</h1>
          <p>Feel free to connect with us for any queries.</p>
        </div>
        <form onSubmit={handelSubmit}>
          <label htmlFor="name">Name</label>
          <br />
          <input
            required
            value={userName}
            onChange={handelUserName}
            name="name"
            type="text"
            placeholder="Enter Name*"
          />
          {nameError != "" ? (
            <span className="lpNewTestFormError">
              {nameError} <br />
            </span>
          ) : null}
          <label htmlFor="phoneNumber">Phone Number</label>
          <br />
          <input
            onBlur={() => {
              validatePhoneNumber();
            }}
            onChange={handelPhoneChange}
            required
            value={userNumber}
            name="phoneNumber"
            type="text"
            placeholder="Enter Phone Number*"
          />
          {phoneError != "" ? (
            <span className="lpNewTestFormError">
              {phoneError} <br />
            </span>
          ) : null}
          <label htmlFor="email">Email</label>
          <br />
          <input
            required
            value={userEmail}
            onChange={handelUserEmail}
            name="email"
            type="text"
            placeholder="Enter Email Address*"
          />
          {emailError != "" ? (
            <span className="lpNewTestFormError">
              {emailError} <br />
            </span>
          ) : null}
          <label htmlFor="age">Age</label>
          <br />
          <input
            required
            value={userAge}
            onChange={handelUserAge}
            name="age"
            type="text"
            placeholder="Enter Age*"
          />
          <label htmlFor="gender">Gender</label>
          <br />
          <select
            required
            value={userGender}
            onChange={handelGender}
            name="gender"
            type="text"
            placeholder=""
          >
            <option value="" disabled selected>
              Select Gender*
            </option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          <br />
          <label htmlFor="city">City*</label>
          <br />
          <input
            type="text"
            placeholder="Enter City"
            onChange={handelCityChange}
            value={userCity}
          />
          {displayCityList ? (
            <div
              className={userCity ? "cityList lpGutcityList" : "displayNone"}
              id="cityList"
            >
              {userCity !== "" && citiesFromArray && citiesFromArray.cities
                ? citiesFromArray.cities
                    .filter((name) => {
                      if (userCity == "") {
                        return name;
                      } else if (
                        name.toLowerCase().includes(userCity.toLowerCase())
                      ) {
                        return name;
                      }
                    })
                    .map((values, index) => {
                      if (index < 2) {
                        return (
                          <>
                            <div
                              onClick={() => setInputcity(values)}
                              key={index}
                              className={
                                displayCityList ? "cityLIstLP" : "displayNone"
                              }
                            >
                              <span>{values}</span>
                            </div>

                            {/* <div
                                className="cityItem"
                                key={index}
                                onClick={() => setCity(filteredName)}
                                >
                                {" "}
                                <span>{filteredName}</span>{" "}
                                </div> */}
                          </>
                        );
                      }
                    })
                : null}
            </div>
          ) : null}

          <button type="submit">SUBMIT</button>
        </form>
      </div>
      <div className="lpGutsDisclaimer">
        <h1 className="noDisplayWeb">DISCLAIMER</h1>
        <p>
          {" "}
          <span className="noDisplayMob">
            <strong>Disclaimer:</strong>
          </span>{" "}
          This Report's role is limited to providing insights into Your gut
          microbiome, with a general set of dietary recommendations and risk
          management. General risk management strategies provided in our Report
          are for information purposes only and in this regard, it is essential
          to understand that every person’s resistance, immunity, sensitivity,
          and response to medication is different, and therefore not all general
          risk management strategies may be suitable to everyone.
        </p>
      </div>
      <Modal open={openSuccModel} onClose={closeSuccess} center>
        <div className="SuccessMsg_upload">
          <h2>
            We have received your information. We shall call you in few minutes
            to confirm the details. For any queries please call us at &nbsp;
            <a href={"tel:+91-898 898 8585"} style={{ color: "blue" }}>
              898 898 8585
            </a>{" "}
            - Team Redcliffe Labs
          </h2>
        </div>
      </Modal>

      {/* Notification popup */}
      <Modal
        classNames={{
          overlay: "customOverlay",
          modal: "notificationPopup_modal",
        }}
        open={open1}
        onClose={onCloseModal1}
        center
      >
        <Popup setOpen={setOpen1} />
      </Modal>
      
    </div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getCall: (body) => {
      dispatch(Actions.getCall(body));
    },
  };
};
export default {
  component: connect(mapDispatchToProps)(React.memo(LpGuts)),
};
